﻿import { INVESTOR_FIRST_YEAR } from '@/types/shared-types'
import { CATEGORY_ALL } from '@/domains/investor/const/InvestorCategories.const'
import { ESecondCategories } from '@/domains/investor/const/SecondCategories.enum'

export const useInvestorFilterOptions = () => {
  const { t } = useI18n()

  const categoryOptions = computed(() => [
    { value: CATEGORY_ALL, label: t('investor.reports.chips.all') },
    { value: ESecondCategories.CURRENT_REPORT, label: t('investor.reports.chips.current') },
    { value: ESecondCategories.YEAR_REPORT, label: t('investor.reports.chips.annual') },
    { value: ESecondCategories.HALF_YEAR_REPORT, label: t('investor.reports.chips.semiAnnual') },
    { value: ESecondCategories.QUARTER_REPORT, label: t('investor.reports.chips.quarterly') },
    { value: ESecondCategories.ORDINARY_ASSEMBLY, label: t('investor.reports.chips.ordinaryAssembly') },
    { value: ESecondCategories.EXTRAORDINARY_ASSEMBLY, label: t('investor.reports.chips.extraOrdinaryAssembly') },
  ])

  const currentYear = new Date().getFullYear()

  const yearOptions = Array.from({ length: currentYear - INVESTOR_FIRST_YEAR + 1 }, (_, index) => ({
    value: currentYear - index,
    label: String(currentYear - index),
  }))

  return {
    categoryOptions,
    yearOptions,
  }
}
